// extracted by mini-css-extract-plugin
export default {"recommendations-container":"RecommendedArticles_recommendations-container__JVTs4","heading":"RecommendedArticles_heading__MwcOa","cards-grid":"RecommendedArticles_cards-grid__c1zoF"};